function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from "react";
import PropTypes from "prop-types";
import { PiCertificate } from "react-icons/pi";
import { Avatar } from "@mui/material";
import classnames from "classnames";
function InvestmentItemAvatar(_ref) {
  var coin = _ref.coin,
    size = _ref.size,
    investmentItem = _ref.investmentItem,
    className = _ref.className,
    imgClassName = _ref.imgClassName,
    style = _ref.style;
  var width, height, borderRadius, iconSize, coinRight, coinTop, coinWidth, coinHeight, coinFontSize;
  if (size === "xs") {
    width = 25;
    height = 25;
    borderRadius = 3;
    iconSize = 20;
    coinRight = -5;
    coinTop = 15;
    coinWidth = 15;
    coinHeight = 15;
    coinFontSize = 6;
  } else if (size === "sm") {
    width = 33;
    height = 33;
    borderRadius = 6;
    iconSize = 22;
    coinRight = -10;
    coinTop = 20;
    coinWidth = 15;
    coinHeight = 15;
    coinFontSize = 6;
  } else if (size === "md") {
    width = 40;
    height = 40;
    borderRadius = 6;
    iconSize = 24;
    coinRight = -5;
    coinTop = 30;
    coinWidth = 20;
    coinHeight = 20;
    coinFontSize = 6;
  } else if (size === "lg") {
    width = 80;
    height = 80;
    borderRadius = 12;
    iconSize = 48;
    coinRight = -10;
    coinTop = 55;
    coinWidth = 35;
    coinHeight = 35;
    coinFontSize = 10;
  } else if (size === "xl") {
    width = 150;
    height = 150;
    borderRadius = 12;
    iconSize = 64;
    coinRight = -20;
    coinTop = 110;
    coinWidth = 60;
    coinHeight = 60;
    coinFontSize = 18;
  } else {
    throw new Error("Size not supported.");
  }
  return investmentItem.picture ? /*#__PURE__*/React.createElement("div", {
    className: classnames("d-inline-block", className),
    style: _objectSpread({
      position: "relative",
      width: width,
      height: height,
      borderRadius: borderRadius
    }, style)
  }, /*#__PURE__*/React.createElement("img", {
    width: width,
    height: height,
    src: investmentItem.picture.src,
    onError: function onError(e) {
      e.target.onerror = null;
      e.target.src = "/img/image_missing.png";
    },
    className: imgClassName,
    style: {
      objectFit: "cover",
      borderRadius: borderRadius
    }
  }), coin && /*#__PURE__*/React.createElement(Avatar, {
    className: "border",
    style: {
      position: "absolute",
      right: coinRight,
      top: coinTop,
      color: "#fff",
      backgroundColor: "#ffd700",
      width: coinWidth,
      height: coinHeight,
      fontSize: coinFontSize,
      fontWeight: 500
    }
  }, investmentItem.symbol || "")) : /*#__PURE__*/React.createElement("div", {
    className: classnames("d-flex", "justify-content-center", "align-items-center", "bg-gradient-brand-primary-to-pink", className),
    style: {
      width: width,
      height: height,
      borderRadius: borderRadius
    }
  }, /*#__PURE__*/React.createElement(PiCertificate, {
    color: "white",
    size: iconSize
  }));
}
export default InvestmentItemAvatar;
InvestmentItemAvatar.defaultProps = {
  coin: false,
  size: "md"
};
InvestmentItemAvatar.propTypes = {
  coin: PropTypes.bool,
  size: PropTypes.string,
  investmentItem: PropTypes.object.isRequired,
  className: PropTypes.string,
  imgClassName: PropTypes.string,
  style: PropTypes.object
};